// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 228 ? "252f366e" : chunkId) + "." + {"88":"e1886bdef7b470fc","161":"0433be92b2380f3c","228":"43482c32ce2d1a5c","651":"9078e83f25d7ee7c","666":"fdce8f590ebaa784","741":"cd9485d61f910928"}[chunkId] + ".js";
};